export default function CopyIcon() {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.8123 11.812H15.1873V2.81201H6.18732V6.18701M2.81226 6.18709H11.8123V15.1871H2.81226V6.18709Z"
          stroke="#4A72FF"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
